(function () {
  var page = document.querySelector('[data-ghost-product-pdp]');
  if (!page) return;

  var buyBox = page.querySelector('[data-ghost-product-pdp-buy-box]');
  var variantInput = page.querySelector('[data-ghost-product-pdp-variant-input]');
  var compareInput = page.querySelector('[data-ghost-product-pdp-compare-input]');
  var priceNode = page.querySelector('[data-ghost-product-pdp-price]');
  var compareNode = page.querySelector('[data-ghost-product-pdp-compare]');
  var imageNode = page.querySelector('[data-ghost-product-pdp-image]');
  var buyButton = page.querySelector('[data-ghost-product-pdp-submit]');
  var stickyBar = page.querySelector('[data-ghost-product-pdp-sticky]');
  var stickyPrice = page.querySelector('[data-ghost-product-pdp-sticky-price]');
  var stickyCompare = page.querySelector('[data-ghost-product-pdp-sticky-compare]');
  var stickySubmit = page.querySelector('[data-ghost-product-pdp-sticky-submit]');

  var lightbox = page.querySelector('[data-ghost-product-pdp-lightbox]');
  var lightboxImage = page.querySelector('[data-ghost-product-pdp-lightbox-image]');
  var lightboxCounter = page.querySelector('[data-ghost-product-pdp-lightbox-counter]');
  var lightboxThumbs = page.querySelector('[data-ghost-product-pdp-lightbox-thumbs]');
  var lightboxClose = page.querySelector('[data-ghost-product-pdp-lightbox-close]');
  var lightboxPrev = page.querySelector('[data-ghost-product-pdp-lightbox-prev]');
  var lightboxNext = page.querySelector('[data-ghost-product-pdp-lightbox-next]');

  var cartVariantIds = new Set();
  var lightboxImages = [];
  var lightboxIndex = 0;

  function parseGallery() {
    var node = page.querySelector('[data-ghost-product-pdp-gallery]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function getActiveVariantButton() {
    return page.querySelector('[data-ghost-product-pdp-variant].is-active')
      || page.querySelector('[data-ghost-product-pdp-variant]');
  }

  function syncStickyPricing() {
    if (!stickyPrice) return;

    if (priceNode) {
      stickyPrice.textContent = priceNode.textContent || '';
    }

    if (stickyCompare && compareNode) {
      if (compareNode.hidden || !compareNode.textContent) {
        stickyCompare.hidden = true;
        stickyCompare.textContent = '';
      } else {
        stickyCompare.hidden = false;
        stickyCompare.textContent = compareNode.textContent;
      }
    }
  }

  function updateBuyButton() {
    if (!buyButton) return;

    var activeVariant = getActiveVariantButton();
    var variantId = String(variantInput ? variantInput.value || '' : '');
    var labelAvailable = buyButton.getAttribute('data-label-available') || 'Add to cart';
    var labelInCart = buyButton.getAttribute('data-label-in-cart') || 'Already in your cart';
    var labelSoldOut = buyButton.getAttribute('data-label-sold-out') || 'Sold out';
    var inCart = variantId && cartVariantIds.has(variantId);

    if (activeVariant && activeVariant.getAttribute('data-available') === 'false') {
      buyButton.disabled = true;
      buyButton.textContent = labelSoldOut;
      buyButton.classList.remove('is-in-cart');
      if (stickySubmit) {
        stickySubmit.disabled = true;
        stickySubmit.textContent = labelSoldOut;
        stickySubmit.classList.remove('is-in-cart');
      }
      return;
    }

    buyButton.disabled = false;

    if (inCart) {
      buyButton.textContent = labelInCart;
      buyButton.classList.add('is-in-cart');
      if (stickySubmit) {
        stickySubmit.disabled = false;
        stickySubmit.textContent = labelInCart;
        stickySubmit.classList.add('is-in-cart');
      }
      return;
    }

    buyButton.textContent = labelAvailable;
    buyButton.classList.remove('is-in-cart');
    if (stickySubmit) {
      stickySubmit.disabled = false;
      stickySubmit.textContent = labelAvailable;
      stickySubmit.classList.remove('is-in-cart');
    }
  }

  function selectVariant(button) {
    var variantButtons = page.querySelectorAll('[data-ghost-product-pdp-variant]');

    variantButtons.forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-pressed', 'false');
    });

    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');

    if (variantInput) {
      variantInput.value = button.getAttribute('data-variant-id') || '';
    }

    if (compareInput) {
      compareInput.value = button.getAttribute('data-compare-at-cents') || '';
    }

    if (priceNode) {
      priceNode.textContent = button.getAttribute('data-price') || '';
    }

    if (compareNode) {
      var comparePrice = button.getAttribute('data-compare-price');
      if (comparePrice) {
        compareNode.textContent = comparePrice;
        compareNode.hidden = false;
      } else {
        compareNode.textContent = '';
        compareNode.hidden = true;
      }
    }

    if (imageNode) {
      var imageUrl = button.getAttribute('data-image-url');
      if (imageUrl) {
        imageNode.src = imageUrl;
        imageNode.srcset = '';
      }
    }

    updateBuyButton();
    syncStickyPricing();
  }

  function syncCartVariants(cart) {
    cartVariantIds.clear();

    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        cartVariantIds.add(String(item.variant_id));
      });
    }

    updateBuyButton();
  }

  page.querySelectorAll('[data-ghost-product-pdp-variant]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled) return;
      if (button.classList.contains('ghost-product-pdp__variant--solo')) return;
      selectVariant(button);
    });
  });

  var soloVariant = page.querySelector('[data-ghost-product-pdp-variant].ghost-product-pdp__variant--solo');
  if (soloVariant && !soloVariant.classList.contains('ghost-product-pdp__variant--pack')) {
    selectVariant(soloVariant);
  }

  page.querySelectorAll('[data-ghost-product-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var imageUrl = thumb.getAttribute('data-image-url');
      if (!imageNode || !imageUrl) return;

      page.querySelectorAll('[data-ghost-product-pdp-thumb]').forEach(function (item) {
        item.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      imageNode.src = imageUrl;
      imageNode.srcset = '';
    });
  });

  var mediaTrigger = page.querySelector('[data-ghost-product-pdp-lightbox-trigger]');
  if (mediaTrigger) {
    mediaTrigger.addEventListener('click', function (event) {
      if (event.target.closest('[data-ghost-product-pdp-thumb]')) return;
      openLightbox();
    });
    mediaTrigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openLightbox();
      }
    });
  }

  function renderLightboxThumbs() {
    if (!lightboxThumbs) return;
    lightboxThumbs.innerHTML = '';

    lightboxImages.forEach(function (url, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = index === lightboxIndex ? 'is-active' : '';
      button.innerHTML = '<img src="' + url.replace(/"/g, '&quot;') + '" alt="">';
      button.addEventListener('click', function () {
        lightboxIndex = index;
        updateLightbox();
      });
      lightboxThumbs.appendChild(button);
    });
  }

  function updateLightbox() {
    if (!lightboxImage || !lightboxImages.length) return;
    lightboxImage.src = lightboxImages[lightboxIndex];
    if (lightboxCounter) {
      lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + lightboxImages.length;
    }
    renderLightboxThumbs();
  }

  function openLightbox() {
    lightboxImages = parseGallery();
    if (!lightboxImages.length && imageNode && imageNode.src) {
      lightboxImages = [imageNode.src];
    }
    if (!lightbox || !lightboxImages.length) return;

    lightboxIndex = 0;
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    updateLightbox();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function stepLightbox(delta) {
    if (!lightboxImages.length) return;
    lightboxIndex = (lightboxIndex + delta + lightboxImages.length) % lightboxImages.length;
    updateLightbox();
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function () { stepLightbox(-1); });
  if (lightboxNext) lightboxNext.addEventListener('click', function () { stepLightbox(1); });
  if (lightbox) {
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!lightbox || lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') stepLightbox(-1);
    if (event.key === 'ArrowRight') stepLightbox(1);
  });

  if (stickySubmit && buyButton) {
    stickySubmit.addEventListener('click', function () {
      if (buyButton.disabled) return;
      buyButton.click();
    });
  }

  function setupStickyBar() {
    if (!stickyBar || !buyButton || window.matchMedia('(min-width: 64rem)').matches) return;

    if ('IntersectionObserver' in window) {
      var observeTarget = buyBox || buyButton;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
        });
      }, { threshold: 0.15 });

      observer.observe(observeTarget);
    } else {
      stickyBar.hidden = false;
    }

    syncStickyPricing();
  }

  document.addEventListener('ghost:cart:updated', function (event) {
    syncCartVariants(event.detail && event.detail.cart ? event.detail.cart : null);
  });

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(syncCartVariants)
    .catch(function () {});

  setupStickyBar();
  syncStickyPricing();
})();
